const categories = [
  {
    name: '',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: [12, 55, '35_r', '54_r'],
    invert: [35, 54],
    negative: false,
    translationKey: 'chalkboard.offensive.team.goals',
    singleName: 'Gol',
  },
  {
    name: '',
    color: '#FFFF00',
    points: [1, 2, 3],
    categories: [510],
    negative: false,
    translationKey: 'chalkboard.offensive.team.shots_on_goal',
    singleName: 'Tiro a gol',
  },
  {
    name: '',
    color: '#9933FF',
    points: [1, 2, 3],
    categories: [537, 540, 544, 547],
    translationKey: 'chalkboard.offensive.team.shots_on_goal_2',
    singleName: 'Tiro a gol (portería)',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: [13, 25],
    translationKey: 'chalkboard.offensive.team.center_crosses',
    singleName: 'Centro',
  },
  {
    name: '',
    color: '#4DB6AC',
    points: [1, 2, 3],
    categories: [98, 101, 104, 105, 109, 112, 115, 116],
    translationKey: 'chalkboard.offensive.team.successful_center_crosses',
    singleName: 'Centro acertado',
  },
  {
    name: '',
    color: '#F06292',
    points: [1, 2],
    categories: [11],
    translationKey: 'chalkboard.offensive.team.balls_won_opponent_penalty_box',
    singleName: 'Balón ganado',
  },
  {
    name: '',
    color: '#3A3838',
    points: [1],
    categories: [4],
    translationKey: 'chalkboard.offensive.team.successful_1_on_1_attacking',
    singleName: '1 vs 1 ofensivo',
  },
  {
    name: '',
    color: '#00B050',
    points: [1],
    categories: [208],
    translationKey: 'chalkboard.offensive.team.unsuccessful_1_on_1_attacking',
    singleName: '1 vs 1 ofensivo',
  },
];

export default categories;
